module.exports = __webpack_public_path__ + "static/media/OTCXR1.eb82c5bb.png";